/**
 * Hook for managing fallacy detail modal state
 * Extracts modal orchestration from components
 */

import { useState } from 'react';
import type { FallacyData } from '@/types/flipped';

export function useFallacyModal() {
  const [selectedFallacy, setSelectedFallacy] = useState<string | null>(null);
  const [selectedFallacyData, setSelectedFallacyData] = useState<FallacyData | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = (fallacyType: string, fallacyData: FallacyData | null) => {
    setSelectedFallacy(fallacyType);
    setSelectedFallacyData(fallacyData);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedFallacy(null);
    setSelectedFallacyData(null);
  };

  return {
    selectedFallacy,
    selectedFallacyData,
    isModalOpen,
    openModal,
    closeModal,
  };
}
